<script>
  import Input from "../input-design/Input.svelte";
  import Editor from "../input-design/Editor.svelte";
  import {
    tokenDetailStore,
    initialTokenDetail,
  } from "../../../stores/tokenStore";
  import { createEventDispatcher, getContext } from "svelte";
  import { replace } from "svelte-spa-router";
  import { isLoaderActive } from "../../../store";
  import { validateField } from "../../../utils";

  const dispatch = createEventDispatcher();

  let fields = initialTokenDetail();
  let errors = initialTokenDetail();

  const saveProject = getContext("save-project");

  const saveFormInDraft = () => {
    if ($isLoaderActive) return;
    isLoaderActive.set(true);
    saveProject(fields);
    isLoaderActive.set(false);
    replace("/sale-listing");
  };

  tokenDetailStore.subscribe((value) => {
    fields = { ...value };
  })();

  const validateTokenDetailForm = () => {
    window.scroll({ top: 0 });

    let valid = true;

    errors.tokenName = validateField(fields.tokenName,"Token name");
    errors.tokenSymbol = validateField(fields.tokenSymbol, "Token symbol");
    errors.projectTokenPrice = validateField(fields.projectTokenPrice,"Token price");
    errors.initialSupply = validateField(fields.initialSupply, "Total Supply");
    errors.tokenDetails = validateField(fields.tokenDetails, "Token details");
  
    valid = !(
      errors.tokenName ||
      errors.tokenSymbol ||
      errors.projectTokenPrice ||
      errors.initialSupply ||
      errors.tokenDetails
    );

    if (fields?.initialSupply?.trim() < 0 || isNaN(fields.initialSupply)) {
      valid = false;
      errors.initialSupply =
        "Total Supply should be integer and greater than 0";
    }

    if (
      fields?.projectTokenPrice?.trim() < 0 ||
      isNaN(fields.projectTokenPrice)
    ) {
      valid = false;
      errors.projectTokenPrice =
        "Project token price should be integer and greater than 0";
    }

    if (!valid) return window.scroll({ top: 0 });

    errors = {
      tokenName: "",
      tokenSymbol: "",
      projectTokenPrice: "",
      initialSupply: "",
      tokenDetails: "",
    };
    tokenDetailStore.setProjectTokenDetail({ ...fields });
    dispatch("next");
    return true;
  };
  const backTop = () => {
    window.scroll({ top: 0 });
  };
</script>

<section class="token-information">
  <p>
    This will be a token minted for the fixed-raise at the time of creation.
    Users will be able to buy these tokens and later on can be used to claim
    actual project tokens.
  </p>
</section>
<section>
  <form>
    <div class="flex flex-wrap form-row items-start">
      <div class="col-6">
        <Input
          bind:value={fields.tokenName}
          on:input={() => (errors = { ...errors, tokenName: "" })}
          placeholder="Enter token name"
          id="rise-token-name"
        >
          <label for="rise-token-name" slot="label" class="form-label">
            Raise Token Name
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            Please choose the name of your token
          </span>
        </Input>
        <div class="error">{errors.tokenName}</div>
      </div>
      <div class="col-6">
        <Input
          bind:value={fields.tokenSymbol}
          on:input={() => (errors = { ...errors, tokenSymbol: "" })}
          placeholder="Enter raise target"
          id="raise-target"
        >
          <label for="raise-target" slot="label" class="form-label">
            Token Symbol
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            Please provide the unique ticker for your token
          </span>
        </Input>
        <div class="error">{errors.tokenSymbol}</div>
      </div>
      <div class="col-6">
        <Input
          bind:value={fields.initialSupply}
          on:input={() => (errors = { ...errors, initialSupply: '' })}
          placeholder="Enter total supply"
          id="total-supply">
          <label for="total-supply" slot="label" class="form-label">
            Total Supply
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            How many tokens do you want to make available
          </span>
        </Input>
        <div class="error">{errors.initialSupply}</div>
      </div>
      <div class="col-6">
        <Input
          bind:value={fields.projectTokenPrice}
          on:input={() => (errors = { ...errors, projectTokenPrice: "" })}
          placeholder="Enter token price"
          id="token-price"
        >
          <label for="token-price" slot="label" class="form-label">
            Project Token Price
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            Define price you wish to set your asset
          </span>
        </Input>
        <div class="error">{errors.projectTokenPrice}</div>
      </div>
      <div class="col-12">
        <label for="" class="form-label">
          Token Details
          <small>*</small>
        </label>
        <span class="form-label-dec">
            Explain what your token details will provide you with
          </span>
        <div id="token-detail-editor">
          <Editor
            initialValue={fields.tokenDetails}
            on:change={(event) => {
              fields.tokenDetails = event.detail["value"];
            }}
          />
        </div>
        <div class="error">{errors.tokenDetails}</div>
      </div>
    </div>
  </form>
</section>
<div class="pl-button-wrapper">
  <button class="pl-button pl-clear-btn" id="token-detail-back" on:click={backTop} on:click={() => dispatch('back')}>
    Back
  </button>
  <button class="pl-button pl-save-btn" id="token-detail-save" on:click={saveFormInDraft}>Save</button>
  <button class="pl-button pl-next-btn" id="token-detail-next" on:click={validateTokenDetailForm}>
    Next
  </button>
</div>
